export default "__VITE_PUBLIC_ASSET__218457d1__"